import { create } from 'zustand';
import { api } from '@/lib/api';

interface NotifState {
  unreadCount: number;
  pollUnread: () => Promise<void>;
  markAllRead: () => Promise<void>;
}

export const useNotifStore = create<NotifState>((set) => ({
  unreadCount: 0,

  pollUnread: async () => {
    try {
      const data = await api.get<{ count: number }>('/notifications/unread-count');
      set({ unreadCount: data.count });
    } catch {
      // ignore
    }
  },

  markAllRead: async () => {
    await api.post('/notifications/mark-read');
    set({ unreadCount: 0 });
  },
}));
